import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Layout, Input, Button, Form, Card, Divider, Table, MenuProps, Dropdown } from "antd";
import { putSupplierService } from "./SuppliersPageService";
import Loader from "../../components/Loader/Loader";
import "./SuppliersPage.css";
import Sidebar from "../../components/Sidebar/Sidebar";
import Header from "../../components/Header/Header";
import Copyright from "../../components/Copyright/Copyright";
import { getSuppliersService, postSupplierService } from "./SuppliersPageService";
import { removeTokenFromCookies } from "../../utils/cookies";
import NewSupplierForm from "../../components/NewSupplierForm/NewSupplierForm";
import Cookies from "universal-cookie";
import { EditOutlined, MoreOutlined } from "@ant-design/icons";

const { Search } = Input;
const { Content } = Layout;

export interface SuppliersPageInterface {}

const SuppliersPage = (props: SuppliersPageInterface) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [pgSuppliers, setPGSuppliers] = useState([]);
  const [bwSuppliers, setBWSuppliers] = useState([]);
  const [editSupplierData, setEditSupplierData] = useState(null) as any;
  const [showSupplierForm, setShowSupplierForm] = useState(false);
  const [pgSearchText, setPGSearchText] = useState("");
  const [bwSearchText, setBWSearchText] = useState("");
  const navigate = useNavigate();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");
  const suppliersColumns = [
    {
      title: "Item Number",
      key: "index",
      align: "center" as const,
      width: "10%",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Name",
      key: "name",
      align: "left" as const,
      width: "30%",
      render: (record: any) => record.name,
    },
    {
      title: "Company Name",
      key: "companyName",
      align: "left" as const,
      width: "20%",
      render: (record: any) => record.companyName,
    },
    {
      title: "IC Number",
      key: "identificationCardNumber",
      align: "center" as const,
      width: "20%",
      render: (record: any) =>
        record.identificationCardNumber ? formatIdentificationCardNumber(record.identificationCardNumber) : null,
    },
    {
      title: "Passport Number",
      key: "passportNumber",
      align: "center" as const,
      width: "20%",
      render: (record: any) => (record.passportNumber ? record.passportNumber : null),
    },
    // {
    //   title: "Phone Number",
    //   key: "supplier",
    //   width: "20%",
    //   align: "center" as const,
    //   render: (record: any) => record.contactNumber,
    // },
    {
      title: "Options",
      key: "options",
      align: "center" as const,
      render: (record: any) => {
        const userRole = cookies.get("USER_ROLE");
        let items: MenuProps["items"] = [];
        items.push({ key: "edit", label: "Edit Supplier", icon: <EditOutlined /> });
        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") openEditSupplierView(record);
              },
            }}
            trigger={["click"]}
          >
            <a onClick={(e) => e.preventDefault()}>
              <MoreOutlined style={{ fontSize: "24px" }} />
            </a>
          </Dropdown>
        );
      },
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    getSuppliers();
  }, []);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const formatIdentificationCardNumber = (identificationCardNumber: string) => {
    return `${identificationCardNumber.slice(0, 6)}-${identificationCardNumber.slice(
      6,
      8
    )}-${identificationCardNumber.slice(8, 12)}`;
  };

  const getSuppliers = async () => {
    try {
      setLoading(true);
      const res = await getSuppliersService();
      setPGSuppliers(res.data.pgSuppliers);
      setBWSuppliers(res.data.bwSuppliers);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const postSupplier = async (supplierInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        name: supplierInfo.name,
        companyName: supplierInfo.companyName,
        identificationCardNumber: supplierInfo.identificationCardNumber.replaceAll(" ", "").replaceAll("-", ""),
        contactNumber: "",
        email: "",
        address: "",
        companyCode: "",
        outstandingAmount: 0.0,
        passportNumber: supplierInfo.passportNumber,
        pgOffice: supplierInfo.pgOffice,
        bwOffice: supplierInfo.bwOffice,
      };
      const res = await postSupplierService(payload);
      setTimeout(async () => {
        setLoading(false);
        await getSuppliers();
      }, 2000);
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const putSupplier = async (supplierInfo: any) => {
    try {
      setLoading(true);
      const payload = {
        supplierID: supplierInfo.supplierID,
        name: supplierInfo.name,
        companyName: supplierInfo.companyName,
        identificationCardNumber: supplierInfo.identificationCardNumber.replaceAll(" ", "").replaceAll("-", ""),
        contactNumber: supplierInfo.contactNumber,
        email: supplierInfo.emailAddress,
        address: supplierInfo.address,
        companyCode: supplierInfo.companyCode,
        passportNumber: supplierInfo.passportNumber,
        pgOffice: supplierInfo.pgOffice,
        bwOffice: supplierInfo.bwOffice,
      };
      const res = await putSupplierService(payload);
      setTimeout(async () => {
        setLoading(false);
        await getSuppliers();
      }, 2000);
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const openEditSupplierView = (record: any) => {
    setEditSupplierData(record);
    openSupplierForm();
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const openSupplierForm = () => {
    setShowSupplierForm(true);
  };

  const closeSupplierForm = () => {
    setShowSupplierForm(false);
  };

  const searchSuppliersPG = async (searchText: string) => {
    if (searchText === "") {
      await getSuppliers();
    } else {
      const currPGSuppliers = [...pgSuppliers];
      const text = searchText.toLocaleLowerCase();
      const searchSuppliers = currPGSuppliers.filter((supplier: any) => {
        if (
          supplier.name !== "" &&
          supplier.name !== undefined &&
          supplier.name.toLocaleLowerCase().search(text) !== -1
        ) {
          return supplier;
        }
        if (
          supplier.companyName !== "" &&
          supplier.companyName !== undefined &&
          supplier.companyName.toLocaleLowerCase().search(text) !== -1
        ) {
          return supplier;
        }
      });
      setPGSuppliers(searchSuppliers);
    }
  };

  const searchSuppliersBW = async (searchText: string) => {
    if (searchText === "") {
      await getSuppliers();
    } else {
      const currBWSuppliers = [...bwSuppliers];
      const text = searchText.toLocaleLowerCase();
      const searchSuppliers = currBWSuppliers.filter((supplier: any) => {
        if (
          supplier.name !== "" &&
          supplier.name !== undefined &&
          supplier.name.toLocaleLowerCase().search(text) !== -1
        ) {
          return supplier;
        }
        if (
          supplier.companyName !== "" &&
          supplier.companyName !== undefined &&
          supplier.companyName.toLocaleLowerCase().search(text) !== -1
        ) {
          return supplier;
        }
      });
      setBWSuppliers(searchSuppliers);
    }
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Header toggleSidebar={toggleSidebar} />
        <Row justify="center">
          <Col span={22}>
            <Row>
              <Col span={12}>
                <Row justify="start">
                  <h2 className="suppliers-title">Suppliers</h2>
                </Row>
              </Col>
              <Col span={12}>
                <Row justify="end" style={{ marginTop: "20px" }}>
                  <Button type="primary" onClick={() => openSupplierForm()}>
                    Add New Supplier
                  </Button>
                </Row>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row justify="start">
              <h2 className="office-suppliers-title">Butterworth List</h2>
            </Row>
            <Row>
              <Search
                placeholder="Name / Company Name"
                allowClear
                enterButton="Search"
                onChange={(e: any) => searchSuppliersBW(e.target.value)}
                style={{ marginBottom: "20px" }}
              />
            </Row>
            <Table dataSource={[...bwSuppliers]} columns={suppliersColumns} />
            <Row justify="start">
              <h2 className="office-suppliers-title">Penang List</h2>
            </Row>
            <Row>
              <Search
                placeholder="Name / Company Name"
                allowClear
                enterButton="Search"
                onChange={(e: any) => searchSuppliersPG(e.target.value)}
                style={{ marginBottom: "20px" }}
              />
            </Row>
            <Table dataSource={[...pgSuppliers]} columns={suppliersColumns} />
          </Col>
        </Row>
        <NewSupplierForm
          showForm={showSupplierForm}
          closeForm={closeSupplierForm}
          editSupplierData={editSupplierData}
          postSupplier={postSupplier}
          putSupplier={putSupplier}
        />
        <Copyright />
      </Content>
    </Layout>
  );
};

export default SuppliersPage;
